import { useEffect, useState } from 'react';
import { isClient } from "./browser.ts";
import { useEventListener } from "./useEventListener.ts";
import { useRequestAnimationFrame } from "./useRequestAnimationFrame.ts";

export interface ScrollPosition {
	x: number;
	y: number;
}

export function getScrollPosition(): ScrollPosition {
	return isClient
		? { x: window.pageXOffset, y: window.pageYOffset }
		: { x: 0, y: 0 };
}

export default function useWindowScrollRaf(throttle = true): ScrollPosition {
	const [position, setPosition] = useState<ScrollPosition>({ x: 0, y: 0 });

	const updater = useRequestAnimationFrame(() => setPosition(getScrollPosition()), throttle);

	if (isClient) {
		useEventListener(window, 'scroll', updater);
		useEventListener(window, 'resize', updater);
	}

	useEffect(() => {
		setPosition(getScrollPosition());
	}, []);

	return position;
}
